import { HttpClient }       from '@angular/common/http';
import { Injectable }       from '@angular/core';
import { Observable }       from 'rxjs';
import { shareReplay }      from 'rxjs/operators';
import { GlobalConstants }  from '../common/global-constants';
import { BOInamovibleCatalog } from '../models/BOInamovibleCatalog.model';

@Injectable()
export class InamovibleCatalogService {

    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/InamovibleCatalog';

    private cache$: Observable<BOInamovibleCatalog> | null = null;

    constructor(private http: HttpClient) {}

    getAll(): Observable<BOInamovibleCatalog> {
        if (!this.cache$) {
            this.cache$ = this.http
                .get<BOInamovibleCatalog>(this.myAppUrl + this.myApiUrl)
                .pipe(shareReplay(1));
        }
        return this.cache$;
    }

    clearCache(): void {
        this.cache$ = null;
    }
}
